import { useEffect } from 'react';

import { posthogApiKey } from '@/env';
import { useFeatureFlagsLoaded } from '@/features/feature-flags';
import { trackEvent } from '@/utils/analytics';

export function useTrackLoginScreenOpened(): void {
  const featureFlagsLoaded = useFeatureFlagsLoaded();
  const flagsReady = featureFlagsLoaded || !posthogApiKey;

  useEffect(() => {
    if (!flagsReady) return;
    trackEvent('LOGIN_SCREEN_OPENED', {
      login_design: 'meadow',
      login_design_source: 'default',
    });
  }, [flagsReady]);
}
